const topics = [
  { name: '流浪地球3', count: '128万讨论', icon: 'ri-rocket-2-line' },
  { name: '古装剧', count: '96万讨论', icon: 'ri-ancient-gate-line' },
  { name: '悬疑推理', count: '83万讨论', icon: 'ri-search-eye-line' },
  { name: '科幻大片', count: '75万讨论', icon: 'ri-planet-line' },
  { name: '都市情感', count: '68万讨论', icon: 'ri-heart-line' },
  { name: '动漫番剧', count: '61万讨论', icon: 'ri-ghost-line' },
  { name: '热门综艺', count: '55万讨论', icon: 'ri-tv-2-line' },
  { name: '韩剧推荐', count: '49万讨论', icon: 'ri-global-line' },
  { name: '纪录片', count: '42万讨论', icon: 'ri-earth-line' },
  { name: '喜剧片', count: '38万讨论', icon: 'ri-emotion-laugh-line' },
  { name: '战争片', count: '31万讨论', icon: 'ri-sword-line' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">热门话题</h2>
            <p className="mt-3 text-sm text-foreground-500">影视爱好者都在讨论什么</p>
          </div>

          <div className="flex flex-wrap justify-center gap-3 md:gap-4">
            {topics.map((topic) => (
              <div
                key={topic.name}
                className="group flex items-center gap-3 px-4 py-3 bg-background-100 hover:bg-accent-100/60 rounded-xl cursor-pointer transition-all duration-200"
              >
                <div className="w-9 h-9 rounded-lg bg-background-200 group-hover:bg-accent-200/60 flex items-center justify-center transition-colors">
                  <i className={`${topic.icon} text-foreground-600 group-hover:text-accent-700 text-sm`}></i>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{topic.name}</p>
                  <p className="text-xs text-foreground-500">{topic.count}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}